import { render, staticRenderFns } from "./CheckResultDetail.vue?vue&type=template&id=50314828&scoped=true&"
import script from "./CheckResultDetail.vue?vue&type=script&lang=ts&"
export * from "./CheckResultDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CheckResultDetail.vue?vue&type=style&index=0&id=50314828&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50314828",
  null
  
)

export default component.exports